

















































































































































import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import {SiteEntity} from "@/entity/SiteEntity";
import {cleanDomain} from "@/store";

/** Karşılaştırma için alan adı (sunucudaki Site::normalizeHost gibi): şema, yol, port, www. atılır */
function hostKey(value: any): string {
    return cleanDomain(value).replace(/:\d+$/, "").replace(/^www\./, "");
}

/** Ek alan adları sunucudaki gibi virgül/boşlukla ayrılır */
function splitHosts(value: any): string[] {
    return String(value || "").split(/[,\s]+/).map(hostKey).filter((host: string) => host !== "");
}

class requestPayload {
    site_id: number | null = null;
    site_key: string = "";
    name: string = "";
    short_name: string = "";
    domain: string = "";
    domain_aliases: string = "";
    form_email: string = "";
    primary_color: string = "#54B8E3";
    logo_url: string = "";
    favicon_url: string = "";
    enabled: number = 1;
    is_default: number = 0;
    no: number = 0;
    clone_from_site_id: number | null = null;
    logo_file: File | null = null;
    favicon_file: File | null = null;
}

@Component({
    components: {EForm}
})
export default class Siteler extends Vue {
    baseAction: string = "sites";
    action: string = this.baseAction;
    dialog: boolean = false;
    title: string = "";
    isNew: boolean = true;
    items: Array<SiteEntity> | null = null;
    data: requestPayload = new requestPayload();

    statusOptions = [
        {text: "Yayında", value: 1},
        {text: "Kapalı", value: 0},
    ];

    get cloneOptions() {
        return (this.items || []).map((site: SiteEntity) => ({
            text: site.name,
            value: window.Number(site.site_id),
        }));
    }

    /** Diğer şubelerin alan adları: host → şube adı */
    get otherHosts(): { [host: string]: string } {
        // Prototipsiz nesne: "constructor" gibi bir ad yanlış çakışma sayılmasın
        const map: { [host: string]: string } = Object.create(null);
        const editingId = this.data.site_id === null ? null : window.Number(this.data.site_id);
        (this.items || []).forEach((site: SiteEntity) => {
            if (editingId !== null && window.Number(site.site_id) === editingId) {
                return;
            }
            splitHosts(site.domain).concat(splitHosts(site.domain_aliases)).forEach((host: string) => {
                if (!map[host]) {
                    map[host] = site.name || site.site_key || "başka şube";
                }
            });
        });
        return map;
    }

    conflictMessage(hosts: string[]): string[] {
        const map = this.otherHosts;
        const found: string[] = [];
        hosts.forEach((host: string) => {
            const text = host + " (" + map[host] + ")";
            if (map[host] && found.indexOf(text) === -1) {
                found.push(text);
            }
        });
        return found.length ? ["Bu alan adı başka bir şubede kullanılıyor: " + found.join(", ")] : [];
    }

    get domainErrors(): string[] {
        const host = hostKey(this.data.domain);
        return host === "" ? [] : this.conflictMessage([host]);
    }

    get aliasErrors(): string[] {
        return this.conflictMessage(splitHosts(this.data.domain_aliases));
    }

    onLogoFile(event: any) {
        const files = event.target.files;
        this.data.logo_file = files && files.length > 0 ? files[0] : null;
    }

    onFaviconFile(event: any) {
        const files = event.target.files;
        this.data.favicon_file = files && files.length > 0 ? files[0] : null;
    }

    add() {
        this.data = new requestPayload();
        this.action = this.baseAction;
        this.title = "Yeni Şube";
        this.isNew = true;
        this.dialog = true;
    }

    edit(item: SiteEntity) {
        this.data = new requestPayload();
        this.data.site_id = window.Number(item.site_id);
        this.data.site_key = item.site_key;
        this.data.name = item.name;
        this.data.short_name = item.short_name || "";
        this.data.domain = item.domain || "";
        this.data.domain_aliases = item.domain_aliases || "";
        this.data.form_email = item.form_email || "";
        this.data.primary_color = item.primary_color || "#54B8E3";
        this.data.logo_url = item.logo_url || "";
        this.data.favicon_url = item.favicon_url || "";
        this.data.enabled = window.Number(item.enabled);
        this.data.is_default = window.Number(item.is_default);
        this.data.no = window.Number(item.no);
        this.action = this.baseAction + "/" + item.site_id;
        this.title = "Şubeyi Düzenle";
        this.isNew = false;
        this.dialog = true;
    }

    activate(item: SiteEntity) {
        this.$store.dispatch("changeSite", window.Number(item.site_id));
    }

    async getSites() {
        this.dialog = false;
        let response = await this.$http.get(this.baseAction);
        this.items = response.data;
        // Üst bardaki seçici de tazelenir
        this.$store.dispatch("loadSites");
    }

    created() {
        this.getSites();
    }
}
